import {
  MATCH_FLEXIBILITY_OPTIONS,
  PROGRAM_TYPE_OPTIONS,
  USAGE_FREQUENCY_OPTIONS,
} from "../ai-curriculum.constants";

import { DropdownField } from "./ai-form-field";

export const StandardsFields = ({ criteria, onChange }) => (
  <div className="ai-form-step__fields">
    <DropdownField
      label="Program Type"
      placeholder="Select a program type"
      options={PROGRAM_TYPE_OPTIONS}
      selected={criteria.programType}
      required
      onChange={(programType) => onChange({ programType })}
    />

    <DropdownField
      label="How Often Will You Use Transfr?"
      placeholder="Select a frequency"
      options={USAGE_FREQUENCY_OPTIONS}
      selected={criteria.usageFrequency}
      required
      onChange={(usageFrequency) => onChange({ usageFrequency })}
    />

    <DropdownField
      label="Match Flexibility"
      placeholder="Select match flexibility"
      options={MATCH_FLEXIBILITY_OPTIONS}
      selected={criteria.matchFlexibility}
      required
      onChange={(matchFlexibility) => onChange({ matchFlexibility })}
    />
  </div>
);
